import { Controller } from '@hotwired/stimulus'
// Importing the package registers the <onepassword-save-button> custom element.
import { activateOPButton } from '@1password/save-button'

// The button's save request is base64-encoded server-side and rendered onto
// the element's `value` attribute. The component only reads `value` when it
// first renders its shadow DOM (`value` isn't in its observedAttributes), so
// setting it from JS after mount is too late — hence baking it in server-side.
//
// All this controller does is tell the 1Password extension to (re-)scan for
// the button, which it otherwise only does on a full page load — the reveal
// banner appears after a Turbo navigation, without one.
export default class extends Controller {
  connect() {
    activateOPButton()
  }
}
